import { Container } from "react-bootstrap";
import "../style/VideoBlock.css";

const VideoBlock = () => {
  return (
    <section className="section-pad video-block">
      <Container className="container-narrow container-narrow--tight text-center">
        <span className="eyebrow">See It Made</span>
        <h2>Watch a Pack Become Breakfast</h2>
        <video
          controls
          loop
          muted
          playsInline
          preload="none"
          poster="/images/dishes/masaladosa.jpg"
          className="video-block__video"
        >
          <source src="/videos/videoautoplay.MP4" type="video/mp4" />
        </video>
      </Container>
    </section>
  );
};

export default VideoBlock;
